<a class="ft-btn-backtotop"
   ft-scroll-to=".ft-scroll-anchor">
    <i class="ft-icn-arrow-up"></i>
</a>

<ui-view />

<ft-create-property />
<ft-create-account />
<ft-spaces />
